/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux';
import { RootState } from '../configureStore';
import { FileUploadInfo } from '../../data/services/FileUploadManager';

export type FileUploadUrlInfo = {
    initUrl: string;
    uploadUrl: string;
    commitUrl: string;
}

export interface UploadState {
    fileUploads: FileUploadInfo[];
    initUrl: string;
    uploadUrl: string;
    commitUrl: string;
    refresh: boolean;
}

export const useUploadState = () => {
    const uploadState = useSelector((state: RootState | any) => state.upload as UploadState);
    return uploadState;
}

// Define the initial state using that type
const initialState: UploadState = {
    fileUploads: [] as FileUploadInfo[],
    commitUrl: '',
    initUrl: '',
    uploadUrl: '',
    refresh: false,
}

export const uploadSlice = createSlice({
    name: 'upload',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        uploadFilesReducer: (state, action: PayloadAction<FileUploadInfo[]>) => {
            const fileUploadInfos = action.payload;
            
            state.fileUploads = [ ...state.fileUploads, ...fileUploadInfos];
        },
        setUploadStartedReducer: (state, action: PayloadAction<{ fileId: string }>) => {
            const { fileId } = action.payload;
            const updatedFileUploads = [...state.fileUploads].map((fileUpload) => fileUpload.fileId === fileId ? { ...fileUpload, uploadStarted: true } : fileUpload);

            state.fileUploads = updatedFileUploads;
        },
        updateFileUploadProgressReducer: (state, action: PayloadAction<{ fileId: string, progress: number }>) => {
            const { fileId, progress } = action.payload;
            const updatedFileUploads = [...state.fileUploads].map((fileUpload) => fileUpload.fileId === fileId ? { ...fileUpload, progress } : fileUpload);
            
            state.refresh = false;
            state.fileUploads = updatedFileUploads;
        },
        updateFileUploadTimeReducer: (state, action: PayloadAction<{ fileId: string, uploadTime: number }>) => {
            const { fileId, uploadTime } = action.payload;
            const updatedFileUploads = [...state.fileUploads].map((fileUpload) => fileUpload.fileId === fileId ? { ...fileUpload, uploadTime, uploadComplete: true } : fileUpload);

            state.fileUploads = updatedFileUploads;
            state.refresh = true;
        },
        setUploadUrlInfoReducer: (state, action: PayloadAction<FileUploadUrlInfo>) => {
            state.initUrl = action.payload.initUrl;
            state.uploadUrl = action.payload.uploadUrl;
            state.commitUrl = action.payload.commitUrl;
        },       
        clearUploadReducer: (state, action: PayloadAction<{fileId: string}>) => {
            const updatedFileUploads = [...state.fileUploads].filter((fileUpload) => fileUpload.fileId !== action.payload.fileId);

            state.fileUploads = updatedFileUploads;
        },
        clearUploadedFilesReducer: (state) => {
            const updatedFileUploads = [...state.fileUploads].filter((fileUpload) => fileUpload.progress < 1);
            state.fileUploads = updatedFileUploads;
        },
        clearAllFilesReducer: (state) => {
            state.fileUploads = [];
        }
    }
})

export const {
    uploadFilesReducer,
    setUploadStartedReducer,
    updateFileUploadProgressReducer,
    updateFileUploadTimeReducer,
    setUploadUrlInfoReducer,
    clearUploadReducer,
    clearUploadedFilesReducer,
    clearAllFilesReducer
} = uploadSlice.actions;

// Other code such as selectors can use the imported `RootState` type
//export const getUser = (state: RootState) => state

export default uploadSlice.reducer;